import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

function Issues() {
  return (
    <Card>
      <Text type="secondary">This is the Issues page. Content coming soon!</Text>
    </Card>
  );
}

export default Issues;
